export default "__VITE_ASSET__BtFqNaKk__"